import React from "react";
import Loader from "./Elements/Loader";
import { connect } from "react-redux";
import TopMenu from "./Layout/TopMenu/TopMenu";
import { Route, Switch, Redirect, Link } from "react-router-dom";
import Login from "./Layout/Login/Login";
import { getUserData } from "./../redux/actions";
import MenuList from "./Elements/MenuList";
// import BottomMenu from "./Elements/BottomMenu";
import { Layout } from "antd";
import { Button, Drawer, notification } from "antd";
import logo from "../assets/img/logo.svg";
import {
  CheckOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { withTranslation } from "react-i18next";
import history from "../const/history";
import Currency from "./Pages/Admin/Currency/Currency";
import ContactInfo from "./Pages/Contact/ContactInfo/ContactInfo";
import EditPost from "./EditPages/EditPost";
import EditContact from "./EditPages/EditContact";
import EditBanks from "./EditPages/EditBanks";
import EditBranches from "./EditPages/EditBranches";
import EditGallery from "./EditPages/EditGallery";
import Full from "./Pages/Posts/Gallery/Full";
import EditProduct from "./Pages/Posts/Products/EditProduct";
import EditRegions from "./EditPages/EditRegions";
import EditDirectory from "./Pages/Company/Directories/EditDirectory";
import EditAbout from "./Pages/Company/About/EditAbout";
import About from "./Pages/Company/About/About";
import Directory from "./Pages/Company/Directories/Directory";
import Products from "./Pages/Posts/Products/Products";
import Banks from "./Pages/Map/Banks/Banks";
import BankBranches from "./Pages/Map/BankBranchs/BankBranches";
import Gallery from "./Pages/Posts/Gallery/Gallery";
import AdminstrativeRegions from "./Pages/Map/AdminstrativeRegions/AdminstrativeRegions";
import Messages from "./Pages/Contact/Messages/Messages";
import Categories from "./Pages/Admin/Categories/Categories";
import Post from "./Pages/Posts/Post/Post";
import Documents from "./Pages/Admin/Documents/Documents";
import Languages from "./Pages/Admin/Languages/Languages";
import Instructions from "./Pages/Admin/Instructions/Instructions";
import Mission from "./Pages/Company/MIssion/Mission";
import EditMission from "./Pages/Company/MIssion/EditMission";
import Faq from "./Pages/Admin/Faq/Faq"
import EditFaq from "./Pages/Admin/Faq/EditFaq";
import Projects from "./Pages/Map/Projects/Projects";
import EditProjects from "./Pages/Map/Projects/EditProjects";
import VideoApply from "./Pages/Contact/VideoApply/VideoApply";
import Terms from "./Pages/Admin/Terms/Terms";
import EditTerms from "./Pages/Admin/Terms/EditTerms";
import Partners from "./Pages/Company/Partners/Partners";
import EditPartners from "./Pages/Company/Partners/EditPartners";
import CreateReport from "./Pages/Company/Reports/CreateReport";
import ProductList from "./Pages/Products/ProductList/ProductList";
import Reports from "./Pages/Company/Reports/Reports";
import Structure from "./Pages/Company/Structure/Structure";
import ProductProperties from "./Pages/Products/ProductProperties/ProductProperties";
import ProductDocuments from "./Pages/Products/ProductDocuments/ProductDocuments";
import Priority from "./Pages/Products/Priority/Priority";
import Chart from "./Pages/Products/Chart/Chart";
import RoadMap from "./Pages/Admin/RoadMap/RoadMap";
import HeadPersons from "./Pages/Admin/HeadPersons/HeadPerson";
import Translations from "./Pages/Admin/Translations/Translations";
const { Content, Sider } = Layout;

class App extends React.Component {
  state = {
    collapsed: window.innerWidth < 1200,
    web: true,
    ismap: false,
    stocks: null,
    isWhite: true,
    cats: [],
  };

  toggleButtons = () => {
    const className = `flex sider-btn ${
      this.state.collapsed ? "all-center" : "flex-between open"
    }`;
    return (
      <div className={className}>
        {!this.state.collapsed ? (
          <Link to="/">
            {" "}
            <img src={logo} alt="" />{" "}
          </Link>
        ) : null}
        <Button type="primary" onClick={this.onCollapse}>
          {this.state.collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </Button>
      </div>
    );
  };

  onCollapse = () => {
    this.setState({ collapsed: !this.state.collapsed });
    this.setState({ web: window.innerWidth > 1200 });
  };

  componentDidMount() {
    localStorage.setItem("locale", "az");
    this.props.getUserData();
    this.setState({ web: window.innerWidth > 1200 });
    window.addEventListener("resize", () => {
      this.setState({
        web: window.innerWidth > 1200,
        collapsed: window.innerWidth < 1200,
      });
    });
    this.setState({
      ismap: window.location.pathname === "/",
      isWhite: window.location.pathname === "/",
    });
    history.listen((location) => {
      this.setState({
        ismap: location.pathname === "/",
        isWhite: location.pathname === "/",
      });
    });
  }

  componentDidUpdate(prevProps) {
    const prev = prevProps.notification;
    const curr = this.props.notification;
    if (prev.notify !== curr.notify) {
      let desc = !curr.isHappy
        ? curr.description?.status === 400
          ? curr.description.data.error
          : this.props.t("errorMessage")
        : curr.description;
      notification.info({
        message: curr.isHappy
          ? this.props.t("successMessage")
          : this.props.t("errMessage"),
        description: desc.length ? desc : null,
        icon: curr.isHappy ? <CheckOutlined /> : <WarningOutlined />,
      });
    }
  }

  render() {
    return (
      <>
        {this.props.isLoading ? <Loader /> : null}
        {this.props.isLoggedIn ? (
          <>
            <div id="page">
              <Layout className="letside">
                {this.state.web ? (
                  <Sider
                    className="side-menu animated slideInLeft"
                    style={{ backgroundColor: "white" }}
                    collapsed={this.state.collapsed}
                    collapsedWidth={80}
                    onCollapse={this.onCollapse}
                    width={300}
                  >
                    {this.toggleButtons()}
                    <MenuList collapsed={this.state.collapsed} />
                    {/*<BottomMenu />*/}
                  </Sider>
                ) : (
                  <Drawer
                    className="drawer"
                    width={320}
                    title={this.toggleButtons()}
                    placement="left"
                    closable={false}
                    onClose={this.onCollapse}
                    visible={!this.state.collapsed}
                    key="key"
                  >
                    <MenuList collapsed={this.state.collapsed} />
                    {/*<BottomMenu />*/}
                  </Drawer>
                )}
                <Layout
                  className={
                    this.state.collapsed
                      ? "collapsedRight"
                      : "nonCollapsedRight"
                  }
                >
                  <TopMenu
                    toggleDrawer={this.onCollapse}
                    showDrawerButton={!this.state.web}
                    collapsed={this.state.collapsed}
                  />
                  <Content>
                    <div className={`page-routes`}>
                      <Switch>
                        <Route exact path={`/`} component={Currency} />
                        <Route
                          exact
                          path={`/categories`}
                          component={Categories}
                        />
                       <Route
                          exact
                          path={`/instructions`}
                          component={Instructions}
                        />
                        <Route
                          exact
                          path={`/translations`}
                          component={Translations}
                        />

                        <Route
                            exact
                            path={`/road-map`}
                            component={RoadMap}
                        />

                        <Route
                          exact
                          path={`/documents`}
                          component={Documents}
                        />

                        <Route
                          exact
                          path={`/languages`}
                          component={Languages}
                        />
                        <Route exact path={`/posts/:id?`} component={Post} />
                        <Route exact path={`/post/:id?`} component={EditPost} />

                        <Route
                          exact
                          path={`/products/edit/:id?`}
                          component={EditProduct}
                        />

                        <Route exact path={`/products`} component={Products} />
                        <Route exact path={`/product-list`} component={ProductList} />
                        <Route exact path={`/product-properties`} component={ProductProperties} />
                        <Route exact path={`/product-documents`} component={ProductDocuments} />
                        <Route exact path={`/product-priority`} component={Priority} />
                        <Route exact path={`/product-chart`} component={Chart} />

                        <Route
                          exact
                          path={`/directories/edit/:id?`}
                          component={EditDirectory}
                        />

                        <Route exact path={`/directories`} component={Directory} />

                        <Route
                          exact
                          path={`/about/edit`}
                          component={EditAbout}
                        />

                        <Route exact path={`/about`} component={About} />

                        <Route exact path={`/mission`} component={Mission} />
                        <Route exact path={`/mission/edit/:id?`} component={EditMission} />

                        <Route
                          exact
                          path={`/gallery/edit/:id?`}
                          component={EditGallery}
                        />

                        <Route
                          exact
                          path={`/gallery/view/:id?`}
                          component={Full}
                        />

                        <Route exact path={`/gallery`} component={Gallery} />

                        <Route
                          exact
                          path={`/banks/edit/:id?`}
                          component={EditBanks}
                        />

                        <Route
                          exact
                          path={`/bank-branches`}
                          component={BankBranches}
                        />

                        <Route
                          exact
                          path={`/bank-branches/edit/:id?`}
                          component={EditBranches}
                        />

                        <Route
                            exact
                            path={`/projects`}
                            component={Projects}
                        />

                        <Route
                            exact
                            path={`/projects/edit/:id?`}
                            component={EditProjects}
                        />



                        <Route
                            exact
                            path={`/persons`}
                            component={HeadPersons}
                        />

                        <Route
                            exact
                            path={`/terms`}
                            component={Terms}
                        />

                        <Route
                            exact
                            path={`/terms/edit/:id?`}
                            component={EditTerms}
                        />


                        <Route
                          exact
                          path={`/faq`}
                          component={Faq}
                        />

                        <Route
                          exact
                          path={`/faq/edit/:id?`}
                          component={EditFaq}
                        />

                        <Route
                            exact
                            path={`/structure`}
                            component={Structure}
                        />




                        <Route
                          exact
                          path={`/partners`}
                          component={Partners}
                        />

                        <Route
                          exact
                          path={`/partners/edit/:id?`}
                          component={EditPartners}
                        />

                        <Route
                            exact
                            path={`/reports`}
                            component={Reports}
                        />


                        <Route exact path={`/banks`} component={Banks} />

                        <Route
                          exact
                          path={`/adminstrative/edit/:id?`}
                          component={EditRegions}
                        />

                        <Route
                          exact
                          path={`/adminstrative`}
                          component={AdminstrativeRegions}
                        />

                        <Route exact path={`/messages`} component={Messages} />
                        <Route
                          exact
                          path={`/contact-info`}
                          component={ContactInfo}
                        />

                        <Route
                            exact
                            path={`/video-apply`}
                            component={VideoApply}
                        />


                        <Route
                          exact
                          path={`/contact-info/edit`}
                          component={EditContact}
                        />
                        <Redirect to="/" />
                        <Route path="/">
                          <p className="flex all-center h-100vh">Not found</p>
                        </Route>
                      </Switch>
                    </div>
                  </Content>
                </Layout>
              </Layout>
            </div>
          </>
        ) : (
          <>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route path="/">
                <div>
                  <p className="flex dir-column all-center h-100vh">
                    Tapılmadı <Link to={"/"}>Ana səhifə</Link>
                  </p>
                </div>
              </Route>
            </Switch>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = ({ user, loader, notification }) => {
  return {
    isLoggedIn: user.isLoggedIn,
    isLoading: loader,
    notification,
  };
};

const exp = withTranslation()(App);
export default connect(mapStateToProps, { getUserData })(exp);
